import Vue from 'vue';

import VueRouter from 'vue-router';

import { Loading } from 'vue-ydui/dist/lib.rem/dialog';

import AppLayout from '@/components/AppLayout';

import AppAddress from '@/components/AppAddress';

import IndexApply from '@/components/IndexApply';

import { InfiniteScroll } from 'vue-ydui/dist/lib.rem/infinitescroll';

import { CitySelect } from 'vue-ydui/dist/lib.rem/cityselect';

import { CheckBox, CheckBoxGroup } from 'vue-ydui/dist/lib.rem/checkbox';

Vue.use(VueRouter);

Vue.component(AppLayout.name, AppLayout);

Vue.component(AppAddress.name, AppAddress);

Vue.component(IndexApply.name, IndexApply);

Vue.component(InfiniteScroll.name, InfiniteScroll);

Vue.component(CitySelect.name, CitySelect);

Vue.component(CheckBox.name, CheckBox);

Vue.component(CheckBoxGroup.name, CheckBoxGroup);

/* 一些驾校报名入口 */
const someDrivingSchoolApply = r => require.ensure([], () => r(require('@/someDrivingSchoolApply')), 'someDrivingSchoolApply');

/* 云之驾App */
// 游客主页
const platformHomeApp = r => require.ensure([], () => r(require('@/platformAppViews/platformHomeApp')), 'platformHomeApp');
const platformHomeDetailsApp = r => require.ensure([], () => r(require('@/platformAppViews/platformHomeApp/platformHomeDetailsApp')), 'platformHomeDetailsApp');
const platformBodyCheckApp = r => require.ensure([], () => r(require('@/platformAppViews/platformHomeApp/platformBodyCheckApp')), 'platformBodyCheckApp');
const platformRuleApp = r => require.ensure([], () => r(require('@/platformAppViews/platformHomeApp/platformRuleApp')), 'platformRuleApp');

const platformOnlineApplyApp = r => require.ensure([], () => r(require('@/platformAppViews/platformOnlineApplyApp')), 'platformOnlineApplyApp');
const platformResultPayZFBApp = r => require.ensure([], () => r(require('@/platformAppViews/platformOnlineApplyApp/platformResultPayZFBApp')), 'platformResultPayZFBApp');
const platformWantKnowApp = r => require.ensure([], () => r(require('@/platformAppViews/platformWantKnowApp')), 'platformWantKnowApp');
const platformRecruitStudentApp = r => require.ensure([], () => r(require('@/platformAppViews/platformRecruitStudentApp')), 'platformRecruitStudentApp');
const platformWarningCoachApp = r => require.ensure([], () => r(require('@/platformAppViews/platformWarningCoachApp')), 'platformWarningCoachApp');

// banner广告
const platformBannerApp = r => require.ensure([], () => r(require('@/platformAppViews/platformBannerApp')), 'platformBannerApp');

/* 车小爱App */
// 点赞教练
const loveUpCoachApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveUpCoachApp')), 'loveUpCoachApp');
// 注册提示
const loveRegisterApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveRegisterApp')), 'loveRegisterApp');
const loveRegisterProtocolApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveRegisterApp/loveRegisterProtocolApp')), 'loveRegisterProtocolApp');
// 我的小爱币
const loveMyLoveCoinApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveMyLoveCoinApp')), 'loveMyLoveCoinApp');
const loveMyLoveCoinHistoryApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveMyLoveCoinApp/loveMyLoveCoinHistoryApp')), 'loveMyLoveCoinHistoryApp');
const loveMyLoveCoinRuleApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveMyLoveCoinApp/loveMyLoveCoinRuleApp')), 'loveMyLoveCoinRuleApp');
// 游客主页
const loveHomeApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveHomeApp')), 'loveHomeApp');
const loveHomeDetailsApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveHomeApp/loveHomeDetailsApp')), 'loveHomeDetailsApp');
const loveBodyCheckApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveHomeApp/loveBodyCheckApp')), 'loveBodyCheckApp');
const loveRuleApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveHomeApp/loveRuleApp')), 'loveRuleApp');

const loveOnlineApplyApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveOnlineApplyApp')), 'loveOnlineApplyApp');
const loveApplyPayApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveOnlineApplyApp/loveApplyPayApp')), 'loveApplyPayApp');
const loveResultPayZFBApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveOnlineApplyApp/loveResultPayZFBApp')), 'loveResultPayZFBApp');
const loveWantKnowApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveWantKnowApp')), 'loveWantKnowApp');

// banner广告
const loveBannerApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveBannerApp')), 'loveBannerApp');

// 更多
const loveMorePageApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveMorePageApp')), 'loveMorePageApp');
// 教学区域
const loveTeachAreaApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveMorePageApp/loveTeachAreaApp')), 'loveTeachAreaApp');
// 我的训练
const loveMyTrainApp = r => require.ensure([], () => r(require('@/carLoveAppViews/loveMyTrainApp')), 'loveMyTrainApp');

/* 车小爱内容 */
// 招生
const loveRecruitStudent = r => require.ensure([], () => r(require('@/carLoveViews/loveRecruitStudent')), 'loveRecruitStudent');

// 产品列表
const loveProductList = r => require.ensure([], () => r(require('@/carLoveViews/loveProductList')), 'loveProductList');

// 产品详情
const loveProductDetails = r => require.ensure([], () => r(require('@/carLoveViews/loveProductList/loveProductDetails')), 'loveProductDetails');

// 练车技巧
const lovePracticeSkills = r => require.ensure([], () => r(require('@/carLoveViews/lovePracticeSkills')), 'lovePracticeSkills');

// 推广查询
const lovePromotionQuery = r => require.ensure([], () => r(require('@/carLoveViews/lovePromotion/promotionQuery.vue')), 'lovePromotionQuery');

// 客户留资
const lovePromotionRegister = r => require.ensure([], () => r(require('@/carLoveViews/lovePromotion/promotionRegister.vue')), 'lovePromotionRegister');

// 报名指南
const loveGuide = r => require.ensure([], () => r(require('@/carLoveViews/loveProductList/loveGuide')), 'loveGuide');

// 体检事项
const loveBodyCheck = r => require.ensure([], () => r(require('@/carLoveViews/loveProductList/loveBodyCheck')), 'loveBodyCheck');

// 体检详情
const loveBodyQuery = r => require.ensure([], () => r(require('@/carLoveViews/loveProductList/loveBodyCheck/loveBodyQuery')), 'loveBodyQuery');

// 体检单过期
const loveHealthList = r => require.ensure([], () => r(require('@/carLoveViews/loveProductList/loveBodyCheck/loveHealthList')), 'loveHealthList');

// 体检地址
const loveHealthAddress = r => require.ensure([], () => r(require('@/carLoveViews/loveProductList/loveBodyCheck/loveHealthAddress')), 'loveHealthAddress');

// 驾考新规
const loveRule = r => require.ensure([], () => r(require('@/carLoveViews/loveProductList/loveRule')), 'loveRule');

// 2017新交规扣分标准
const loveNewRule = r => require.ensure([], () => r(require('@/carLoveViews/loveProductList/loveRule/loveNewRule')), 'loveNewRule');
// 酒驾新规
const loveDrunkDriving = r => require.ensure([], () => r(require('@/carLoveViews/loveProductList/loveRule/loveDrunkDriving')), 'loveDrunkDriving');

// 报名
const loveOnlineApply = r => require.ensure([], () => r(require('@/carLoveViews/loveOnlineApply')), 'loveOnlineApply');

// 公众号支付完成后跳转页
const loveResultPayOfficial = r => require.ensure([], () => r(require('@/carLoveViews/loveOnlineApply/loveResultPayOfficial')), 'loveResultPayOfficial');

// 了解
const loveWantKnow = r => require.ensure([], () => r(require('@/carLoveViews/loveWantKnow')), 'loveWantKnow');

// 报名查询
const loveApplyQuery = r => require.ensure([], () => r(require('@/carLoveViews/loveApplyQuery')), 'loveApplyQuery');

// 学车流程
const loveNotice = r => require.ensure([], () => r(require('@/carLoveViews/loveNotice')), 'loveNotice');

// 报名证件
const loveNoticePapers = r => require.ensure([], () => r(require('@/carLoveViews/loveNotice/loveNoticePapers')), 'loveNoticePapers');

// 体检流程
const loveNoticeFlow = r => require.ensure([], () => r(require('@/carLoveViews/loveNotice/loveNoticeFlow')), 'loveNoticeFlow');

// 关于车小爱
const loveAbout = r => require.ensure([], () => r(require('@/carLoveViews/loveAbout')), 'loveAbout');

// 公司简介
const loveAboutUs = r => require.ensure([], () => r(require('@/carLoveViews/loveAbout/loveAboutUs')), 'loveAboutUs');

// 联系我们
const loveAboutAddress = r => require.ensure([], () => r(require('@/carLoveViews/loveAbout/loveAboutAddress')), 'loveAboutAddress');

// 最新活动
const loveActivity = r => require.ensure([], () => r(require('@/carLoveViews/loveActivity')), 'loveActivity');

// 下载App
const loveDownLoadApp = r => require.ensure([], () => r(require('@/carLoveViews/loveDownLoadApp')), 'loveDownLoadApp');

// 微校区
const loveSmallSchool = r => require.ensure([], () => r(require('@/carLoveViews/loveSmallSchool')), 'loveSmallSchool');
// 微相册
const lovePhoto = r => require.ensure([], () => r(require('@/carLoveViews/loveSmallSchool/lovePhoto')), 'lovePhoto');
// 微相册详情
const lovePhotoDetail = r => require.ensure([], () => r(require('@/carLoveViews/loveSmallSchool/lovePhoto/lovePhotoDetail')), 'lovePhotoDetail');
// 校区位置
const loveSchoolAddress = r => require.ensure([], () => r(require('@/carLoveViews/loveSmallSchool/loveSchoolAddress')), 'loveSchoolAddress');
// 校区位置详情
const loveSchoolAddressDetail = r => require.ensure([], () => r(require('@/carLoveViews/loveSmallSchool/loveSchoolAddress/loveSchoolAddressDetail')), 'loveSchoolAddressDetail');
// 我的微校区
const loveMy = r => require.ensure([], () => r(require('@/carLoveViews/loveSmallSchool/loveMy')), 'loveMy');
// 驾校航拍
const loveAerialPhoto = r => require.ensure([], () => r(require('@/carLoveViews/loveSmallSchool/loveAerialPhoto')), 'loveAerialPhoto');
// 驾校航拍详情
const loveAerialPhotoDetail = r => require.ensure([], () => r(require('@/carLoveViews/loveSmallSchool/loveAerialPhoto/loveAerialPhotoDetail')), 'loveAerialPhotoDetail');
// 最新热点
const loveNewActive = r => require.ensure([], () => r(require('@/carLoveViews/loveSmallSchool/loveNewActive')), 'loveNewActive');


// 车小爱理论题库
const loveStudyScope = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope')), 'loveStudyScope');
// 考规
const loveStudyRule1 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/newRule/studyRule1')), 'loveStudyRule1');
const loveStudyRule2 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/newRule/studyRule2')), 'loveStudyRule2');
const loveStudyRule3 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/newRule/studyRule3')), 'loveStudyRule3');
const loveStudyRule4 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/newRule/studyRule4')), 'loveStudyRule4');
// 车小爱答题技巧
const loveAnswer = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/answer')), 'loveAnswer');
const loveAnswerTip1 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/answer/answerTip/answerTip1')), 'loveAnswerTip1');
const loveAnswerTip2 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/answer/answerTip/answerTip2')), 'loveAnswerTip2');
const loveAnswerTip3 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/answer/answerTip/answerTip3')), 'loveAnswerTip3');
const loveAnswerTip4 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/answer/answerTip/answerTip4')), 'loveAnswerTip4');
const loveAnswerTip5 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/answer/answerTip/answerTip5')), 'loveAnswerTip5');
const loveAnswerTip6 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/answer/answerTip/answerTip6')), 'loveAnswerTip6');
const loveAnswerTip7 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/answer/answerTip/answerTip7')), 'loveAnswerTip7');
const loveAnswerTip8 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/answer/answerTip/answerTip8')), 'loveAnswerTip8');
// 车小爱经验技巧
const loveExperience2 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/experience/experience2')), 'loveExperience2');
const loveExperience2Tip1 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/experience/experience2/experience2Tip/experience2Tip1')), 'loveExperience2Tip1');
const loveExperience2Tip2 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/experience/experience2/experience2Tip/experience2Tip2')), 'loveExperience2Tip2');
const loveExperience2Tip3 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/experience/experience2/experience2Tip/experience2Tip3')), 'loveExperience2Tip3');
const loveExperience2Tip4 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/experience/experience2/experience2Tip/experience2Tip4')), 'loveExperience2Tip4');
const loveExperience2Tip5 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/experience/experience2/experience2Tip/experience2Tip5')), 'loveExperience2Tip5');
const loveExperience2Tip6 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/experience/experience2/experience2Tip/experience2Tip6')), 'loveExperience2Tip6');
const loveExperience2Tip7 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/experience/experience2/experience2Tip/experience2Tip7')), 'loveExperience2Tip7');
const loveExperience2Tip8 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/experience/experience2/experience2Tip/experience2Tip8')), 'loveExperience2Tip8');
const loveExperience2Tip9 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/experience/experience2/experience2Tip/experience2Tip9')), 'loveExperience2Tip9');

const loveExperience3 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/experience/experience3')), 'loveExperience3');
const loveExperience3Tip1 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/experience/experience3/experience3Tip/experience3Tip1')), 'loveExperience2Tip1');
const loveExperience3Tip2 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/experience/experience3/experience3Tip/experience3Tip2')), 'loveExperience2Tip2');
const loveExperience3Tip3 = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/experience/experience3/experience3Tip/experience3Tip3')), 'loveExperience2Tip3');

const loveBeforeExam = r => require.ensure([], () => r(require('@/carLoveViews/loveStudyScope/beforeExam')), 'loveBeforeExam');

// 题库
// 在线练习
const loveExercise = r => require.ensure([], () => r(require('@/carLoveViews/loveQuestionBank/questionCont/exercise')), 'exercise');
// 模拟考试
const loveSimulate = r => require.ensure([], () => r(require('@/carLoveViews/loveQuestionBank/questionCont/simulate')), 'loveSimulate');
/* 消息 */
const m0001 = r => require.ensure([], () => r(require('@/messageApp/m0001')), 'm0001');


/* 荣安App */
// 驾校信息
const schoolInfoApp = r => require.ensure([], () => r(require('@/ronganAppViews/schoolInfoApp')), 'schoolInfoApp');
// 引导页
const guidePicApp = r => require.ensure([], () => r(require('@/ronganAppViews/guidePicApp')), 'guidePicApp');
// 游客首页
const homeApp = r => require.ensure([], () => r(require('@/ronganAppViews/homeApp')), 'homeApp');
// 游客驾校详情
const homeDetailsApp = r => require.ensure([], () => r(require('@/ronganAppViews/homeApp/homeDetailsApp')), 'homeDetailsApp');
const bodyCheckApp = r => require.ensure([], () => r(require('@/ronganAppViews/homeApp/bodyCheckApp')), 'bodyCheckApp');
const ruleApp = r => require.ensure([], () => r(require('@/ronganAppViews/homeApp/ruleApp')), 'ruleApp');
// 游客报名
const onlineApplyApp = r => require.ensure([], () => r(require('@/ronganAppViews/onlineApplyApp')), 'onlineApplyApp');
// 订单支付结果
const resultPayZFBApp = r => require.ensure([], () => r(require('@/ronganAppViews/onlineApplyApp/resultPayZFBApp.vue')), 'resultPayZFBApp');
// 游客了解
const wantKnowApp = r => require.ensure([], () => r(require('@/ronganAppViews/wantKnowApp')), 'wantKnowApp');

// 报名查询
const applyQueryApp = r => require.ensure([], () => r(require('@/ronganAppViews/applyQueryApp')), 'applyQueryApp');

// 理论课预约
const theoryOrder = r => require.ensure([], () => r(require('@/ronganAppViews/theoryOrder')), 'theoryOrder');

// 理论课预约班车
const busOrder = r => require.ensure([], () => r(require('@/ronganAppViews/theoryOrder/busOrder')), 'busOrder');

// 考场信息
const examinationMessageApp = r => require.ensure([], () => r(require('@/ronganAppViews/examinationMessageApp')), 'examinationMessageApp');
// 投诉
const complaintApp = r => require.ensure([], () => r(require('@/ronganAppViews/complaintApp')), 'complaintApp');
const feedBackApp = r => require.ensure([], () => r(require('@/ronganAppViews/complaintApp/feedBackApp')), 'feedBackApp');
// 原生首页banner
const bannerApp = r => require.ensure([], () => r(require('@/ronganAppViews/bannerApp')), 'bannerApp');
// 全流程分享
const allProcessShareApp = r => require.ensure([], () => r(require('@/ronganAppViews/bannerApp/allProcessShareApp')), 'allProcessShareApp');
/* 荣安教练app */
// 招生主页
const recruitStudent = r => require.ensure([], () => r(require('@/ronganCoachAppViews/recruitStudent')), 'recruitStudent');
// 学员列表
const studentListApp = r => require.ensure([], () => r(require('@/ronganCoachAppViews/studentListApp')), 'studentListApp');
const feeList = r => require.ensure([], () => r(require('@/ronganCoachAppViews/studentListApp/feeList.vue')), 'feeList');

const studentDetailApp = r => require.ensure([], () => r(require('@/ronganCoachAppViews/studentDetailApp')), 'studentDetailApp');
// 我的绩效
const myPerformanceApp = r => require.ensure([], () => r(require('@/ronganCoachAppViews/myPerformanceApp')), 'myPerformanceApp');
const myPerformChooseModelApp = r => require.ensure([], () => r(require('@/ronganCoachAppViews/myPerformanceApp/myPerformChooseModelApp')), 'myPerformChooseModelApp');
// 预约训练
const orderTrainApp = r => require.ensure([], () => r(require('@/ronganCoachAppViews/orderTrainApp')), 'orderTrainApp');
// 预约训练选择时段
const orderTrainChooseDateApp = r => require.ensure([], () => r(require('@/ronganCoachAppViews/orderTrainApp/orderTrainChooseDateApp')), 'orderTrainChooseDateApp');
// 预约训练选择教练
const orderCoachChoose = r => require.ensure([], () => r(require('@/ronganCoachAppViews/orderTrainApp/orderCoachChoose')), 'orderCoachChoose');
// 设备故障码列表
const facilityFaultApp = r => require.ensure([], () => r(require('@/ronganCoachAppViews/facilityFaultApp')), 'facilityFaultApp');
// 学员评估
const studentAssessApp = r => require.ensure([], () => r(require('@/ronganCoachAppViews/studentAssessApp')), 'studentAssessApp');
// 能力评估
const competentAssessApp = r => require.ensure([], () => r(require('@/ronganCoachAppViews/studentAssessApp/competentAssessApp')), 'competentAssessApp');
// 消息分享
const shareStudentApp = r => require.ensure([], () => r(require('@/ronganCoachAppViews/shareStudentApp')), 'shareStudentApp');
/* 荣安公众号内容 */
// 404 NOT FOUND
const notFound = r => require.ensure([], () => r(require('@/views/error/404.vue')), 'notFound');

// 视频学习
const videoParts = r => require.ensure([], () => r(require('@/views/videoStudies/part')), 'videoParts');
const videoLessons = r => require.ensure([], () => r(require('@/views/videoStudies')), 'videoLessons');
const videoPlay = r => require.ensure([], () => r(require('@/views/videoStudies/videoPlay')), 'videoPlay');

// 考场
// 考场首页
const exam = r => require.ensure([], () => r(require('@/views/exam')), 'exam');
// 教练身份认证
const coachIdentify = r => require.ensure([], () => r(require('@/views/exam/coach/identify.vue')), 'coachIdentify');
// 学员身份认证
const studentIdentify = r => require.ensure([], () => r(require('@/views/exam/student/identify.vue')), 'studentIdentify');
// 管理员身份认证
const managerIdentify = r => require.ensure([], () => r(require('@/views/exam/manager/identify.vue')), 'managerIdentify');
// 教练首页
const coachMain = r => require.ensure([], () => r(require('@/views/exam/coach/main.vue')), 'coachMain');
// 管理员首页
const managerMain = r => require.ensure([], () => r(require('@/views/exam/manager/main.vue')), 'managerMain');
// 学员首页
const studentMain = r => require.ensure([], () => r(require('@/views/exam/student/main.vue')), 'studentMain');
// 订单管理
const orderList = r => require.ensure([], () => r(require('@/views/exam/order/orderList.vue')), 'orderList');
// 订单支付确认
const orderConfirm = r => require.ensure([], () => r(require('@/views/exam/order/orderConfirm.vue')), 'orderConfirm');
//  支付成功
const orderPayResult = r => require.ensure([], () => r(require('@/views/exam/order/orderPayResult.vue')), 'orderPayResult');
// 车辆管理
//  新车注册
const vehicelRegister = r => require.ensure([], () => r(require('@/views/exam/coach/vehicelRegister.vue')), 'vehicelRegister');
//  车辆查询
const vehicelList = r => require.ensure([], () => r(require('@/views/exam/coach/vehicelList.vue')), 'vehicelList');
// 账户中心
const accountCenter = r => require.ensure([], () => r(require('@/views/exam/account/accountCenter.vue')), 'accountCenter');
// 账户明细
const accountDetail = r => require.ensure([], () => r(require('@/views/exam/account/accountDetail.vue')), 'accountDetail');
// 教练充值
const personRecharge = r => require.ensure([], () => r(require('@/views/exam/account/personRecharge.vue')), 'personRecharge');
// 教练车充值
const vehicleRecharge = r => require.ensure([], () => r(require('@/views/exam/account/vehicleRecharge.vue')), 'vehicleRecharge');
//  充值成功
const rechargingResult = r => require.ensure([], () => r(require('@/views/exam/account/rechargeResult.vue')), 'rechargingResult');
// 预约
// 模式选择
const modelSelection = r => require.ensure([], () => r(require('@/views/exam/booking/modelSelection.vue')), 'modelSelection');
// 课程选择
const lessionSelection = r => require.ensure([], () => r(require('@/views/exam/booking/lessionSelection.vue')), 'lessionSelection');
// 时间选择
const timeSelection = r => require.ensure([], () => r(require('@/views/exam/booking/timeSelection.vue')), 'timeSelection');
// 圈数选择
const turnsSelection = r => require.ensure([], () => r(require('@/views/exam/booking/turnsSelection.vue')), 'turnsSelection');
// 选择确认
const selectionConfirm = r => require.ensure([], () => r(require('@/views/exam/booking/selectionConfirm.vue')), 'selectionConfirm');
// 结果
const bookingResult = r => require.ensure([], () => r(require('@/views/exam/booking/bookingResult.vue')), 'bookingResult');
// 预约列表
const bookingList = r => require.ensure([], () => r(require('@/views/exam/booking/bookingList.vue')), 'bookingList');
// 管理员
// 管理员预约查看
const recordList = r => require.ensure([], () => r(require('@/views/exam/manager/recordList.vue')), 'recordList');
// 管理员工作记录
const workList = r => require.ensure([], () => r(require('@/views/exam/manager/workList.vue')), 'workList');
// 管理员扫描签到--车辆确认
const vehicelConfirm = r => require.ensure([], () => r(require('@/views/exam/manager/vehicelConfirm.vue')), 'vehicelConfirm');
// 管理员扫描签退--超时免单
const overTimeOrder = r => require.ensure([], () => r(require('@/views/exam/manager/overTimeOrder.vue')), 'overTimeOrder');
// 首页
const home = r => require.ensure([], () => r(require('@/views/home')), 'home');

// 轮播图
const bannerDetail = r => require.ensure([], () => r(require('@/views/bannerDetail')), 'bannerDetail');

// 驾校详情
const homeDetails = r => require.ensure([], () => r(require('@/views/home/homeDetails')), 'homeDetails');

// 我的 (个人中心首页)
const ucenter = r => require.ensure([], () => r(require('@/views/ucenter')), 'ucenter');

// 报名
const stutentSign = r => require.ensure([], () => r(require('@/views/market/stutentSign')), 'stutentSign');

// 在线报名查询
const applyQuery = r => require.ensure([], () => r(require('@/views/apply_query')), 'apply_query');

// 报名指南
const guide = r => require.ensure([], () => r(require('@/views/guide')), 'guide');

// 注册
const coachRegister = r => require.ensure([], () => r(require('@/views/coachRegister')), 'coachRegister');

// 推广查询
const promotionQuery = r => require.ensure([], () => r(require('@/views/promotion/promotionQuery.vue')), 'promotionQuery');

// 客户留资
const promotionRegister = r => require.ensure([], () => r(require('@/views/promotion/promotionRegister.vue')), 'promotionRegister');

// 我的推荐
const myRecommend = r => require.ensure([], () => r(require('@/views/myRecommend')), 'myRecommend');

// 微校区
const smallSchool = r => require.ensure([], () => r(require('@/views/smallSchool')), 'smallSchool');

// 在线报名
const onlineApply = r => require.ensure([], () => r(require('@/views/onlineApply')), 'onlineApply');
// 支付成功后查询页
const resultPayOfficial = r => require.ensure([], () => r(require('@/views/onlineApply/resultPayOfficial')), 'resultPayOfficial');
// 支付详情
const applyDetails = r => require.ensure([], () => r(require('@/views/onlineApply/applyDetails')), 'applyDetails');

// 我想了解
const wantKnow = r => require.ensure([], () => r(require('@/views/wantKnow')), 'wantKnow');

// 体检事项
const bodyCheck = r => require.ensure([], () => r(require('@/views/bodyCheck')), 'bodyCheck');

// 体检详情
const bodyQuery = r => require.ensure([], () => r(require('@/views/bodyCheck/bodyQuery')), 'bodyQuery');

// 体检单过期
const healthList = r => require.ensure([], () => r(require('@/views/bodyCheck/healthList')), 'healthList');

// 体检地址
const healthAddress = r => require.ensure([], () => r(require('@/views/bodyCheck/healthAddress')), 'healthAddress');

// 驾考新规
const rule = r => require.ensure([], () => r(require('@/views/rule')), 'rule');

// 2017新交规扣分标准
const newRule = r => require.ensure([], () => r(require('@/views/rule/newRule')), 'newRule');
// 酒驾新规
const drunkDriving = r => require.ensure([], () => r(require('@/views/rule/drunkDriving')), 'drunkDriving');

// 理论题库
const studyScope = r => require.ensure([], () => r(require('@/views/studyScope')), 'studyScope');
// 考规
const studyRule1 = r => require.ensure([], () => r(require('@/views/studyScope/newRule/studyRule1')), 'studyRule1');
const studyRule2 = r => require.ensure([], () => r(require('@/views/studyScope/newRule/studyRule2')), 'studyRule2');
const studyRule3 = r => require.ensure([], () => r(require('@/views/studyScope/newRule/studyRule3')), 'studyRule3');
const studyRule4 = r => require.ensure([], () => r(require('@/views/studyScope/newRule/studyRule4')), 'studyRule4');
// 答题技巧
const answer = r => require.ensure([], () => r(require('@/views/studyScope/answer')), 'answer');
const answerTip1 = r => require.ensure([], () => r(require('@/views/studyScope/answer/answerTip/answerTip1')), 'answerTip1');
const answerTip2 = r => require.ensure([], () => r(require('@/views/studyScope/answer/answerTip/answerTip2')), 'answerTip2');
const answerTip3 = r => require.ensure([], () => r(require('@/views/studyScope/answer/answerTip/answerTip3')), 'answerTip3');
const answerTip4 = r => require.ensure([], () => r(require('@/views/studyScope/answer/answerTip/answerTip4')), 'answerTip4');
const answerTip5 = r => require.ensure([], () => r(require('@/views/studyScope/answer/answerTip/answerTip5')), 'answerTip5');
const answerTip6 = r => require.ensure([], () => r(require('@/views/studyScope/answer/answerTip/answerTip6')), 'answerTip6');
const answerTip7 = r => require.ensure([], () => r(require('@/views/studyScope/answer/answerTip/answerTip7')), 'answerTip7');
const answerTip8 = r => require.ensure([], () => r(require('@/views/studyScope/answer/answerTip/answerTip8')), 'answerTip8');
// 经验技巧
const experience2 = r => require.ensure([], () => r(require('@/views/studyScope/experience/experience2')), 'experience2');
const experience2Tip1 = r => require.ensure([], () => r(require('@/views/studyScope/experience/experience2/experience2Tip/experience2Tip1')), 'experience2Tip1');
const experience2Tip2 = r => require.ensure([], () => r(require('@/views/studyScope/experience/experience2/experience2Tip/experience2Tip2')), 'experience2Tip2');
const experience2Tip3 = r => require.ensure([], () => r(require('@/views/studyScope/experience/experience2/experience2Tip/experience2Tip3')), 'experience2Tip3');
const experience2Tip4 = r => require.ensure([], () => r(require('@/views/studyScope/experience/experience2/experience2Tip/experience2Tip4')), 'experience2Tip4');
const experience2Tip5 = r => require.ensure([], () => r(require('@/views/studyScope/experience/experience2/experience2Tip/experience2Tip5')), 'experience2Tip5');
const experience2Tip6 = r => require.ensure([], () => r(require('@/views/studyScope/experience/experience2/experience2Tip/experience2Tip6')), 'experience2Tip6');
const experience2Tip7 = r => require.ensure([], () => r(require('@/views/studyScope/experience/experience2/experience2Tip/experience2Tip7')), 'experience2Tip7');
const experience2Tip8 = r => require.ensure([], () => r(require('@/views/studyScope/experience/experience2/experience2Tip/experience2Tip8')), 'experience2Tip8');
const experience2Tip9 = r => require.ensure([], () => r(require('@/views/studyScope/experience/experience2/experience2Tip/experience2Tip9')), 'experience2Tip9');

const experience3 = r => require.ensure([], () => r(require('@/views/studyScope/experience/experience3')), 'experience3');
const experience3Tip1 = r => require.ensure([], () => r(require('@/views/studyScope/experience/experience3/experience3Tip/experience3Tip1')), 'experience2Tip1');
const experience3Tip2 = r => require.ensure([], () => r(require('@/views/studyScope/experience/experience3/experience3Tip/experience3Tip2')), 'experience2Tip2');
const experience3Tip3 = r => require.ensure([], () => r(require('@/views/studyScope/experience/experience3/experience3Tip/experience3Tip3')), 'experience2Tip3');

const beforeExam = r => require.ensure([], () => r(require('@/views/studyScope/beforeExam')), 'beforeExam');

// 个人信息
const personalDetails = r => require.ensure([], () => r(require('@/views/personal_details')), 'personal_details');

// 题库
const questionBank = r => require.ensure([], () => r(require('@/views/questionBank')), 'questionBank');

// 在线练习
const exercise = r => require.ensure([], () => r(require('@/views/questionBank/questionCont/exercise')), 'exercise');

// 模拟考试
const simulate = r => require.ensure([], () => r(require('@/views/questionBank/questionCont/simulate')), 'simulate');

// 科目二训练和单放日志
const training2Log = r => require.ensure([], () => r(require('@/views/teachingJournal/subject2/training2Log')), 'training2Log');
// 科目二考核日志
const inspection2Log = r => require.ensure([], () => r(require('@/views/teachingJournal/subject2/inspection2Log')), 'inspection2Log');

// 科目三训练日志
const training3Log = r => require.ensure([], () => r(require('@/views/teachingJournal/subject3/training3Log')), 'training3Log');
// 科目三考核日志
const inspection3Log = r => require.ensure([], () => r(require('@/views/teachingJournal/subject3/inspection3Log')), 'inspection3Log');
// 科目三同车互动
const sameCarInteractionLog = r => require.ensure([], () => r(require('@/views/teachingJournal/subject3/sameCarInteractionLog')), 'sameCarInteractionLog');

/** 中驾微信公众号 start */
// 中驾介绍
const aboutZhongJia = r => require.ensure([], () => r(require('@/zhongjiaViews/aboutUs')), 'aboutZhongJia');
const partMenu = r => require.ensure([], () => r(require('@/zhongjiaViews/partMenu')), 'partMenu');
const zhongjiaExamPart1 = r => require.ensure([], () => r(require('@/zhongjiaViews/exam/part1')), 'zhongjiaExamPart1');
const zhongjiaExamPart2 = r => require.ensure([], () => r(require('@/zhongjiaViews/exam/part2')), 'zhongjiaExamPart2');
const zhongjiaExamPart3 = r => require.ensure([], () => r(require('@/zhongjiaViews/exam/part3')), 'zhongjiaExamPart3');
const zhongjiaExamPart4 = r => require.ensure([], () => r(require('@/zhongjiaViews/exam/part4')), 'zhongjiaExamPart4');


// 产品列表
const zhongjiaProduct = r => require.ensure([], () => r(require('@/zhongjiaViews/product')), 'zhongjiaProduct');
// 报名指南
const zhongjiaGuide = r => require.ensure([], () => r(require('@/zhongjiaViews/guide')), 'zhongjiaGuide');
// 体检事项
const zhongjiaBodyCheck = r => require.ensure([], () => r(require('@/zhongjiaViews/bodyCheck')), 'zhongjiaBodyCheck');
// 色弱是否可以学车
const zhongjiaBodyQuery = r => require.ensure([], () => r(require('@/zhongjiaViews/bodyCheck/bodyQuery')), 'zhongjiaBodyQuery');
// 体检单过期
const zhongjiaHealthList = r => require.ensure([], () => r(require('@/zhongjiaViews/bodyCheck/healthList')), 'zhongjiaHealthList');
// 驾考新规
const zhongjiaRule = r => require.ensure([], () => r(require('@/zhongjiaViews/rule')), 'zhongjiaRule');
// 2017新交规扣分标准
const zhongjiaNewRule = r => require.ensure([], () => r(require('@/zhongjiaViews/rule/newRule')), 'zhongjiaNewRule');
// 酒驾新规
const zhongjiaDrunkDriving = r => require.ensure([], () => r(require('@/zhongjiaViews/rule/drunkDriving')), 'zhongjiaDrunkDriving');
// 我想了解
const zhongjiaWantKnow = r => require.ensure([], () => r(require('@/zhongjiaViews/wantKnow')), 'zhongjiaWantKnow');
// 在线报名
const zhongjiaOnlineApply = r => require.ensure([], () => r(require('@/zhongjiaViews/onlineApply')), 'zhongjiaOnlineApply');
// 支付成功后查询页
const zhongjiaPayResult = r => require.ensure([], () => r(require('@/zhongjiaViews/onlineApply/payResult')), 'zhongjiaPayResult');
// 我要注册
const zhongjiaReferrer = r => require.ensure([], () => r(require('@/zhongjiaViews/referrer')), 'zhongjiaReferrer');
// 我的推荐
const zhongjiaRecommend = r => require.ensure([], () => r(require('@/zhongjiaViews/recommend')), 'zhongjiaRecommend');
/** 中驾微信公众号 end */

const constRouterMap = [
  // 一些驾校报名入口
  { path: '/someDrivingSchoolApply', name: 'someDrivingSchoolApply', component: someDrivingSchoolApply },
  // 云之驾App
  { path: '/platformHomeApp', name: 'platformHomeApp', component: platformHomeApp },
  { path: '/platformHomeDetailsApp', name: 'platformHomeDetailsApp', component: platformHomeDetailsApp },
  { path: '/platformBodyCheckApp', name: 'platformBodyCheckApp', component: platformBodyCheckApp },
  { path: '/platformRuleApp', name: 'platformRuleApp', component: platformRuleApp },

  { path: '/platformOnlineApplyApp', name: 'platformOnlineApplyApp', component: platformOnlineApplyApp },
  { path: '/platformResultPayZFBApp', name: 'platformResultPayZFBApp', component: platformResultPayZFBApp },
  { path: '/platformWantKnowApp', name: 'platformWantKnowApp', component: platformWantKnowApp },
  { path: '/platformRecruitStudentApp', name: 'platformRecruitStudentApp', component: platformRecruitStudentApp },
  { path: '/platformBannerApp', name: 'platformBannerApp', component: platformBannerApp },
  { path: '/platformWarningCoachApp', name: 'platformWarningCoachApp', component: platformWarningCoachApp },

  // 车小爱App
  { path: '/loveUpCoachApp', name: 'loveUpCoachApp', component: loveUpCoachApp },
  { path: '/loveRegisterApp', name: 'loveRegisterApp', component: loveRegisterApp },
  { path: '/loveRegisterProtocolApp', name: 'loveRegisterProtocolApp', component: loveRegisterProtocolApp },
  { path: '/loveMyLoveCoinApp', name: 'loveMyLoveCoinApp', component: loveMyLoveCoinApp },
  { path: '/loveMyLoveCoinHistoryApp', name: 'loveMyLoveCoinHistoryApp', component: loveMyLoveCoinHistoryApp },
  { path: '/loveMyLoveCoinRuleApp', name: 'loveMyLoveCoinRuleApp', component: loveMyLoveCoinRuleApp },
  // 游客首页
  { path: '/loveHomeApp', name: 'loveHomeApp', component: loveHomeApp },
  { path: '/loveHomeDetailsApp', name: 'loveHomeDetailsApp', component: loveHomeDetailsApp },
  { path: '/loveBodyCheckApp', name: 'loveBodyCheckApp', component: loveBodyCheckApp },
  { path: '/loveRuleApp', name: 'loveRuleApp', component: loveRuleApp },

  { path: '/loveOnlineApplyApp', name: 'loveOnlineApplyApp', component: loveOnlineApplyApp },
  { path: '/loveApplyPayApp', name: 'loveApplyPayApp', component: loveApplyPayApp },
  { path: '/loveResultPayZFBApp', name: 'loveResultPayZFBApp', component: loveResultPayZFBApp },
  { path: '/loveWantKnowApp', name: 'loveWantKnowApp', component: loveWantKnowApp },
  // 更多
  { path: '/loveMorePageApp', name: 'loveMorePageApp', component: loveMorePageApp },
  { path: '/loveTeachAreaApp', name: 'loveTeachAreaApp', component: loveTeachAreaApp },
  { path: '/loveMyTrainApp', name: 'loveMyTrainApp', component: loveMyTrainApp },
  // 车小爱
  { path: '/loveRecruitStudent', name: 'loveRecruitStudent', component: loveRecruitStudent },
  { path: '/loveBannerApp', name: 'loveBannerApp', component: loveBannerApp },
  { path: '/loveProductList', name: 'loveProductList', component: loveProductList },
  { path: '/loveProductDetails', name: 'loveProductDetails', component: loveProductDetails },
  // 练车技巧
  { path: '/lovePracticeSkills', name: 'lovePracticeSkills', component: lovePracticeSkills },
  // 推广查询
  { path: '/lovePromotionQuery', name: 'lovePromotionQuery', component: lovePromotionQuery },
  { path: '/lovePromotionRegister', name: 'lovePromotionRegister', component: lovePromotionRegister },
  // 报名指南
  { path: '/loveGuide', name: 'loveGuide', component: loveGuide },
  { path: '/loveBodyCheck', name: 'loveBodyCheck', component: loveBodyCheck },
  { path: '/loveBodyQuery', name: 'loveBodyQuery', component: loveBodyQuery },
  { path: '/loveHealthList', name: 'loveHealthList', component: loveHealthList },
  { path: '/loveHealthAddress', name: 'loveHealthAddress', component: loveHealthAddress },
  { path: '/loveRule', name: 'loveRule', component: loveRule },
  { path: '/loveNewRule', name: 'loveNewRule', component: loveNewRule },
  { path: '/loveDrunkDriving', name: 'loveDrunkDriving', component: loveDrunkDriving },

  { path: '/loveWantKnow', name: 'loveWantKnow', component: loveWantKnow },
  // 报名
  { path: '/loveOnlineApply', name: 'loveOnlineApply', component: loveOnlineApply },
  { path: '/loveResultPayOfficial', name: 'loveResultPayOfficial', component: loveResultPayOfficial },
  { path: '/loveApplyQuery', name: 'loveApplyQuery', component: loveApplyQuery },

  { path: '/loveNotice', name: 'loveNotice', component: loveNotice },
  { path: '/loveNotice/loveNoticePapers', name: 'loveNoticePapers', component: loveNoticePapers },
  { path: '/loveNotice/loveNoticeFlow', name: 'loveNoticeFlow', component: loveNoticeFlow },

  { path: '/loveAbout', name: 'loveAbout', component: loveAbout },
  { path: '/loveAbout/loveAboutUs', name: 'loveAboutUs', component: loveAboutUs },
  { path: '/loveAbout/loveAboutAddress', name: 'loveAboutAddress', component: loveAboutAddress },

  { path: '/loveActivity', name: 'loveActivity', component: loveActivity },

  { path: '/loveDownLoadApp', name: 'loveDownLoadApp', component: loveDownLoadApp },

  { path: '/loveSmallSchool', name: 'loveSmallSchool', component: loveSmallSchool },

  { path: '/loveSmallSchool/lovePhoto', name: 'lovePhoto', component: lovePhoto },
  { path: '/loveSmallSchool/lovePhoto/lovePhotoDetail', name: 'lovePhotoDetail', component: lovePhotoDetail },

  { path: '/loveSmallSchool/loveSchoolAddress', name: 'loveSchoolAddress', component: loveSchoolAddress },
  { path: '/loveSmallSchool/loveSchoolAddress/loveSchoolAddressDetail', name: 'loveSchoolAddressDetail', component: loveSchoolAddressDetail },

  { path: '/loveMy', name: 'loveMy', component: loveMy },

  { path: '/loveAerialPhoto', name: 'loveAerialPhoto', component: loveAerialPhoto },

  { path: '/loveAerialPhotoDetail', name: 'loveAerialPhotoDetail', component: loveAerialPhotoDetail },

  { path: '/loveNewActive', name: 'loveNewActive', component: loveNewActive },
  // 车小爱题库
  { path: '/loveQuestionBank/questionCont/exercise', name: 'loveExercise', component: loveExercise },
  { path: '/loveQuestionBank/questionCont/simulate', name: 'loveSimulate', component: loveSimulate },


  { path: '/loveStudyScope', name: 'loveStudyScope', component: loveStudyScope },
  { path: '/loveStudyScope/newRule/studyRule1', name: 'loveStudyRule1', component: loveStudyRule1 },
  { path: '/loveStudyScope/newRule/studyRule2', name: 'loveStudyRule2', component: loveStudyRule2 },
  { path: '/loveStudyScope/newRule/studyRule3', name: 'loveStudyRule3', component: loveStudyRule3 },
  { path: '/loveStudyScope/newRule/studyRule4', name: 'loveStudyRule4', component: loveStudyRule4 },

  { path: '/loveStudyScope/answer', name: 'loveAnswer', component: loveAnswer },
  { path: '/loveStudyScope/answer/answerTip/answerTip1', name: 'loveAnswerTip1', component: loveAnswerTip1 },
  { path: '/loveStudyScope/answer/answerTip/answerTip2', name: 'loveAnswerTip2', component: loveAnswerTip2 },
  { path: '/loveStudyScope/answer/answerTip/answerTip3', name: 'loveAnswerTip3', component: loveAnswerTip3 },
  { path: '/loveStudyScope/answer/answerTip/answerTip4', name: 'loveAnswerTip4', component: loveAnswerTip4 },
  { path: '/loveStudyScope/answer/answerTip/answerTip5', name: 'loveAnswerTip5', component: loveAnswerTip5 },
  { path: '/loveStudyScope/answer/answerTip/answerTip6', name: 'loveAnswerTip6', component: loveAnswerTip6 },
  { path: '/loveStudyScope/answer/answerTip/answerTip7', name: 'loveAnswerTip7', component: loveAnswerTip7 },
  { path: '/loveStudyScope/answer/answerTip/answerTip8', name: 'loveAnswerTip8', component: loveAnswerTip8 },

  { path: '/loveStudyScope/experience/experience2', name: 'loveExperience2', component: loveExperience2 },
  { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip1', name: 'loveExperience2Tip1', component: loveExperience2Tip1 },
  { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip2', name: 'loveExperience2Tip2', component: loveExperience2Tip2 },
  { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip3', name: 'loveExperience2Tip3', component: loveExperience2Tip3 },
  { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip4', name: 'loveExperience2Tip4', component: loveExperience2Tip4 },
  { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip5', name: 'loveExperience2Tip5', component: loveExperience2Tip5 },
  { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip6', name: 'loveExperience2Tip6', component: loveExperience2Tip6 },
  { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip7', name: 'loveExperience2Tip7', component: loveExperience2Tip7 },
  { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip8', name: 'loveExperience2Tip8', component: loveExperience2Tip8 },
  { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip9', name: 'loveExperience2Tip9', component: loveExperience2Tip9 },

  { path: '/loveStudyScope/experience/experience3', name: 'loveExperience3', component: loveExperience3 },
  { path: '/loveStudyScope/experience/experience3/experience3Tip/experience3Tip1', name: 'loveExperience3Tip1', component: loveExperience3Tip1 },
  { path: '/loveStudyScope/experience/experience3/experience3Tip/experience3Tip2', name: 'loveExperience3Tip2', component: loveExperience3Tip2 },
  { path: '/loveStudyScope/experience/experience3/experience3Tip/experience3Tip3', name: 'loveExperience3Tip3', component: loveExperience3Tip3 },

  { path: '/loveStudyScope/beforeExam', name: 'loveBeforeExam', component: loveBeforeExam },
  // 消息提醒
  { path: '/messageApp/m0001', name: 'm0001', meta: { keepAlive: false }, component: m0001 },
  // 荣安App
  { path: '/guidePicApp', name: 'guidePicApp', component: guidePicApp },
  { path: '/ronganInfo', name: 'schoolInfoApp', component: schoolInfoApp },
  { path: '/homeApp', name: 'homeApp', component: homeApp },
  { path: '/homeDetailsApp', name: 'homeDetailsApp', component: homeDetailsApp },
  { path: '/bodyCheckApp', name: 'bodyCheckApp', component: bodyCheckApp },
  { path: '/ruleApp', name: 'ruleApp', component: ruleApp },

  { path: '/onlineApplyApp', name: 'onlineApplyApp', component: onlineApplyApp },
  { path: '/resultPayZFBApp', name: 'resultPayZFBApp', component: resultPayZFBApp },
  { path: '/wantKnowApp', name: 'wantKnowApp', component: wantKnowApp },

  { path: '/applyQueryApp', name: 'applyQueryApp', component: applyQueryApp },

  { path: '/theoryOrder', name: 'theoryOrder', component: theoryOrder },

  { path: '/busOrder', name: 'busOrder', component: busOrder },

  { path: '/examinationMessageApp', name: 'examinationMessageApp', component: examinationMessageApp },

  { path: '/complaintApp', name: 'complaintApp', component: complaintApp },
  { path: '/feedBackApp', name: 'feedBackApp', component: feedBackApp },
  { path: '/bannerApp', name: 'bannerApp', component: bannerApp },
  { path: '/allProcessShareApp', name: 'allProcessShareApp', component: allProcessShareApp },
  // 荣安教练app

  { path: '/recruitStudent', name: 'recruitStudent', component: recruitStudent },
  { path: '/studentDetailApp', name: 'studentDetailApp', component: studentDetailApp },

  { path: '/studentListApp', name: 'studentListApp', meta: { keepAlive: false }, component: studentListApp },
  { path: '/studentListApp/feeList', name: 'feeList', component: feeList },

  { path: '/myPerformanceApp', name: 'myPerformanceApp', component: myPerformanceApp },
  { path: '/myPerformChooseModelApp', name: 'myPerformChooseModelApp', component: myPerformChooseModelApp },

  { path: '/orderTrainApp', name: 'orderTrainApp', component: orderTrainApp },
  { path: '/orderTrainChooseDateApp', name: 'orderTrainChooseDateApp', component: orderTrainChooseDateApp },

  { path: '/orderCoachChoose', name: 'orderCoachChoose', component: orderCoachChoose },
  { path: '/facilityFaultApp', name: 'facilityFaultApp', component: facilityFaultApp },

  { path: '/studentAssessApp', name: 'studentAssessApp', component: studentAssessApp },
  { path: '/competentAssessApp', name: 'competentAssessApp', component: competentAssessApp },

  { path: '/shareStudentApp', name: 'shareStudentApp', component: shareStudentApp },
  // 荣安公众号
  { path: '/', redirect: '/home' },
  { path: '/home', name: 'home', component: home },
  { path: '/home/homeDetails', name: 'homeDetails', component: homeDetails },
  { path: '/bannerDetail', name: 'bannerDetail', component: bannerDetail },

  { path: '/questionBank', name: 'questionBank', component: questionBank },
  { path: '/questionBank/questionCont/exercise', name: 'exercise', component: exercise },
  { path: '/questionBank/questionCont/simulate', name: 'simulate', component: simulate },

  { path: '/ucenter', name: 'ucenter', component: ucenter },
  { path: '/apply_query', name: 'apply_query', component: applyQuery },
  { path: '/personal_details', name: 'personal_details', component: personalDetails },
  { path: '/market/stutentSign/:orgCode', name: 'stutentSign', component: stutentSign },
  { path: '/guide', name: 'guide', component: guide },
  { path: '/onlineApply', name: 'onlineApply', component: onlineApply },
  { path: '/onlineApply/applyDetails', name: 'applyDetails', component: applyDetails },
  { path: '/resultPayOfficial', name: 'resultPayOfficial', component: resultPayOfficial },
  { path: '/wantKnow', name: 'wantKnow', component: wantKnow },

  { path: '/promotionQuery', name: 'promotionQuery', component: promotionQuery },
  // 由于字数限制缩短路径名
  { path: '/pR', name: 'promotionRegister', component: promotionRegister },
  { path: '/coachRegister', name: 'coachRegister', component: coachRegister },
  { path: '/smallSchool', name: 'smallSchool', component: smallSchool },
  { path: '/myRecommend', name: 'myRecommend', component: myRecommend },

  { path: '/bodyCheck', name: 'bodyCheck', component: bodyCheck },
  { path: '/bodyQuery', name: 'bodyQuery', component: bodyQuery },
  { path: '/healthList', name: 'healthList', component: healthList },
  { path: '/healthAddress', name: 'healthAddress', component: healthAddress },

  { path: '/rule', name: 'rule', component: rule },
  { path: '/newRule', name: 'newRule', component: newRule },
  { path: '/drunkDriving', name: 'drunkDriving', component: drunkDriving },

  { path: '/studyScope', name: 'studyScope', component: studyScope },
  { path: '/studyScope/newRule/studyRule1', name: 'studyRule1', component: studyRule1 },
  { path: '/studyScope/newRule/studyRule2', name: 'studyRule2', component: studyRule2 },
  { path: '/studyScope/newRule/studyRule3', name: 'studyRule3', component: studyRule3 },
  { path: '/studyScope/newRule/studyRule4', name: 'studyRule4', component: studyRule4 },

  { path: '/studyScope/answer', name: 'answer', component: answer },
  { path: '/studyScope/answer/answerTip/answerTip1', name: 'answerTip1', component: answerTip1 },
  { path: '/studyScope/answer/answerTip/answerTip2', name: 'answerTip2', component: answerTip2 },
  { path: '/studyScope/answer/answerTip/answerTip3', name: 'answerTip3', component: answerTip3 },
  { path: '/studyScope/answer/answerTip/answerTip4', name: 'answerTip4', component: answerTip4 },
  { path: '/studyScope/answer/answerTip/answerTip5', name: 'answerTip5', component: answerTip5 },
  { path: '/studyScope/answer/answerTip/answerTip6', name: 'answerTip6', component: answerTip6 },
  { path: '/studyScope/answer/answerTip/answerTip7', name: 'answerTip7', component: answerTip7 },
  { path: '/studyScope/answer/answerTip/answerTip8', name: 'answerTip8', component: answerTip8 },

  { path: '/studyScope/experience/experience2', name: 'experience2', component: experience2 },
  { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip1', name: 'experience2Tip1', component: experience2Tip1 },
  { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip2', name: 'experience2Tip2', component: experience2Tip2 },
  { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip3', name: 'experience2Tip3', component: experience2Tip3 },
  { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip4', name: 'experience2Tip4', component: experience2Tip4 },
  { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip5', name: 'experience2Tip5', component: experience2Tip5 },
  { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip6', name: 'experience2Tip6', component: experience2Tip6 },
  { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip7', name: 'experience2Tip7', component: experience2Tip7 },
  { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip8', name: 'experience2Tip8', component: experience2Tip8 },
  { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip9', name: 'experience2Tip9', component: experience2Tip9 },

  { path: '/studyScope/experience/experience3', name: 'experience3', component: experience3 },
  { path: '/studyScope/experience/experience3/experience3Tip/experience3Tip1', name: 'experience3Tip1', component: experience3Tip1 },
  { path: '/studyScope/experience/experience3/experience3Tip/experience3Tip2', name: 'experience3Tip2', component: experience3Tip2 },
  { path: '/studyScope/experience/experience3/experience3Tip/experience3Tip3', name: 'experience3Tip3', component: experience3Tip3 },

  { path: '/studyScope/beforeExam', name: 'beforeExam', component: beforeExam },

  { path: '/teachingJournal/subject2/training2Log', name: 'training2Log', component: training2Log },
  { path: '/teachingJournal/subject2/inspection2Log', name: 'inspection2Log', component: inspection2Log },

  { path: '/teachingJournal/subject3/training3Log', name: 'training3Log', component: training3Log },
  { path: '/teachingJournal/subject3/inspection3Log', name: 'inspection3Log', component: inspection3Log },
  { path: '/teachingJournal/subject3/sameCarInteractionLog', name: 'sameCarInteractionLog', component: sameCarInteractionLog },
  { path: '*', redirect: '/404' },
  { path: '/404', name: '404', component: notFound },

  // 视频播放
  { path: '/video/part', name: 'videoParts', component: videoParts },
  { path: '/video/lesson', name: 'videoLessons', component: videoLessons },
  { path: '/video/play', name: 'videoPlay', component: videoPlay },
  // 微信-考场
  { path: '/exam', name: 'exam', component: exam },
  { path: '/exam/coach/identify', name: 'coachIdentify', component: coachIdentify },
  { path: '/exam/coach/main', name: 'coachMain', component: coachMain },
  { path: '/exam/coach/vehicel/register', name: 'vehicelRegister', component: vehicelRegister },
  { path: '/exam/coach/vehicel/list', name: 'vehicelList', component: vehicelList },
  { path: '/exam/student/identify', name: 'studentIdentify', component: studentIdentify },
  { path: '/exam/student/main', name: 'studentMain', component: studentMain },
  { path: '/exam/manager/identify', name: 'managerIdentify', component: managerIdentify },
  { path: '/exam/manager/main', name: 'managerMain', component: managerMain },
  { path: '/exam/manager/recordList', name: 'recordList', component: recordList },
  { path: '/exam/manager/workList', name: 'workList', component: workList },
  { path: '/exam/manager/vehicelConfirm', name: 'vehicelConfirm', component: vehicelConfirm },
  { path: '/exam/manager/overTimeOrder', name: 'overTimeOrder', component: overTimeOrder },
  { path: '/exam/booking/modelSelection', name: 'modelSelection', component: modelSelection },
  { path: '/exam/booking/lessionSelection', name: 'lessionSelection', component: lessionSelection },
  { path: '/exam/booking/timeSelection', name: 'timeSelection', component: timeSelection },
  { path: '/exam/booking/turnsSelection', name: 'turnsSelection', component: turnsSelection },
//  { path: '/exam/booking/selectionConfirm'，name: 'selectionConfirm', component: selectionConfirm},
  { path: '/exam/booking/bookingResult', name: 'bookingResult', component: bookingResult },
  { path: '/exam/booking/bookingList', name: 'bookingList', component: bookingList },
//  { path: '/exam/booking/payConfirm', name: 'payConfirm', component: payConfirm },
  { path: '/exam/account/center', name: 'accountCenter', component: accountCenter },
  { path: '/exam/account/detail', name: 'accountDetail', component: accountDetail },
  { path: '/exam/order/orderList', name: 'orderList', component: orderList },
//  { path: '/exam/order/orderConfirm', name: 'orderConfirm', component: orderConfirm },
  { path: '/personRecharge', name: 'personRecharge', component: personRecharge },
  { path: '/vehicleRecharge', name: 'vehicleRecharge', component: vehicleRecharge },
  { path: '/rechargeResult', name: 'rechargingResult', component: rechargingResult },
  { path: '/selectionConfirm', name: 'selectionConfirm', component: selectionConfirm },
  { path: '/orderConfirm', name: 'orderConfirm', component: orderConfirm },
  { path: '/orderPayResult', name: 'orderPayResult', component: orderPayResult },
  /** 中驾公众号 start */
  { path: '/zhongjiaProduct', name: 'zhongjiaProduct', component: zhongjiaProduct },

  { path: '/zhongjiaGuide', name: 'zhongjiaGuide', component: zhongjiaGuide },

  { path: '/zhongjiaBodyCheck', name: 'zhongjiaBodyCheck', component: zhongjiaBodyCheck },
  { path: '/zhongjiaBodyQuery', name: 'zhongjiaBodyQuery', component: zhongjiaBodyQuery },
  { path: '/zhongjiaHealthList', name: 'zhongjiaHealthList', component: zhongjiaHealthList },

  { path: '/zhongjiaRule', name: 'zhongjiaRule', component: zhongjiaRule },
  { path: '/zhongjiaNewRule', name: 'zhongjiaNewRule', component: zhongjiaNewRule },
  { path: '/zhongjiaDrunkDriving', name: 'zhongjiaDrunkDriving', component: zhongjiaDrunkDriving },

  { path: '/zhongjiaWantKnow', name: 'zhongjiaWantKnow', component: zhongjiaWantKnow },

  { path: '/zhongjiaOnlineApply', name: 'zhongjiaOnlineApply', component: zhongjiaOnlineApply },
  { path: '/zhongjiaPayResult', name: 'zhongjiaPayResult', component: zhongjiaPayResult },

  { path: '/aboutZhongJia', name: 'aboutZhongJia', component: aboutZhongJia },

  { path: '/partMenu', name: 'partMenu', component: partMenu },
  { path: '/zhongjiaExamPart1', name: 'zhongjiaExamPart1', component: zhongjiaExamPart1 },
  { path: '/zhongjiaExamPart2', name: 'zhongjiaExamPart2', component: zhongjiaExamPart2 },
  { path: '/zhongjiaExamPart3', name: 'zhongjiaExamPart3', component: zhongjiaExamPart3 },
  { path: '/zhongjiaExamPart4', name: 'zhongjiaExamPart4', component: zhongjiaExamPart4 },

  { path: '/zhongjiaReferrer', name: 'zhongjiaReferrer', component: zhongjiaReferrer },
  { path: '/zhongjiaRecommend', name: 'zhongjiaRecommend', component: zhongjiaRecommend },
  /** 中驾公众号 end */

];

const router = new VueRouter({
  // mode: 'history',
  saveScrollPosition: true,
  routes: constRouterMap,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (from.meta.keepAlive) {
      from.meta.savedPosition = document.body.scrollTop;
    }
    return { x: 0, y: to.meta.savedPosition || 0 };
  },
});

router.beforeEach((to, from, next) => {
  Loading.open('\0');
  next();
});

router.afterEach(() => {
  setTimeout(() => {
    Loading.close();
  }, 200);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js